/* ============================================================
   Auto-configurator (Shopify, thema Horizon) — marka → model → rocznik → nadwozie → drzwi
   Dane i reguły pochodzą WYŁĄCZNIE z window.AUTA (baza-aut.js).
   Ten plik niczego z reguł nie duplikuje: pyta AUTA.czyDrzwi /
   czyDoplata / czyKontakt oraz AUTA.reguly.doplataKwota.
   ============================================================ */
(function () {
  'use strict';
  if (window.customElements.get('auto-configurator')) return;

  var POLA = ['marka', 'model', 'generacja', 'nadwozie', 'drzwi'];

  /* Zapamiętany wybór per blok — przeżywa podmianę HTML sekcji
     (np. gdy motyw przerysowuje produkt po zmianie wariantu). */
  var zapamietane = {};

  function pusty() { return { marka: '', model: '', generacja: '', nadwozie: '', drzwi: '' }; }

  /* „sleutel=Naam" per regel of gescheiden door | */
  function mapa(tekst) {
    var wynik = {};
    (tekst || '').split(/\r?\n|\|/).forEach(function (regel) {
      var i = regel.indexOf('=');
      if (i > 0) wynik[regel.slice(0, i).trim()] = regel.slice(i + 1).trim();
    });
    return wynik;
  }

  function znajdz(lista, klucz, wartosc) {
    for (var i = 0; i < lista.length; i++) if (lista[i][klucz] === wartosc) return lista[i];
    return null;
  }

  class AutoKonfigurator extends HTMLElement {
    connectedCallback() {
      if (this._gotowy) return;
      var A = window.AUTA;
      if (!A || !A.m || typeof A.czyDrzwi !== 'function') {
        console.error('[auto-configurator] Brak window.AUTA — czy baza-aut.js ładuje się przed tym plikiem?');
        return;
      }
      this._gotowy = true;
      this.A = A;
      this.klucz = this.dataset.key || 'domyslny';
      this.formId = this.dataset.formId;
      this.drzwiOpcje = (this.dataset.drzwi || '3,5').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      this.s = Object.assign(pusty(), zapamietane[this.klucz] || {});

      /* Weergave in de taal van de klant; wat in de bestelling komt blijft
         altijd Nederlands (labels-nl, deuropties, modelnamen uit de database). */
      this.etykiety = mapa(this.dataset.labels);
      this.etykietyNl = mapa(this.dataset.labelsNl);
      this.modele = mapa(this.dataset.modellen);
      this.drzwiEtykiety = (this.dataset.drzwiLabels || '').split(',').map(function (x) { return x.trim(); });

      var q = this.querySelector.bind(this);
      var self2 = this;
      this.el = {
        marka: q('[data-field="marka"]'),
        model: q('[data-field="model"]'),
        generacja: q('[data-field="generacja"]'),
        nadwozie: q('[data-group="nadwozie"]'),
        drzwi: q('[data-group="drzwi"]'),
        flagaDoplata: q('[data-flag="doplata"]'),
        flagaKontakt: q('[data-flag="kontakt"]'),
        notaDoplata: q('[data-note="doplata"]'),
        notaKontakt: q('[data-note="kontakt"]'),
        kwota: q('[data-kwota]'),
        podsumowanie: q('[data-summary]'),
        podsumowanieTekst: q('[data-summary-text]'),
        blad: q('[data-error]'),
        bladLista: q('[data-error-list]'),
        kroki: q('[data-steps]'),
        reczny: q('[data-manual]'),
        recznyInput: q('[data-manual-input]'),
        recznyPrzycisk: q('[data-manual-toggle]')
      };
      /* Handmatige invoer: auto staat niet in de lijst. */
      this.handmatig = !!(zapamietane[this.klucz] && zapamietane[this.klucz]._handmatig);
      if (this.el.recznyPrzycisk) {
        this.el.recznyPrzycisk.addEventListener('click', function () {
          self2.handmatig = !self2.handmatig;
          self2.sync();
          if (self2.handmatig && self2.el.recznyInput) self2.el.recznyInput.focus();
        });
      }
      if (this.el.recznyInput) {
        this.el.recznyInput.addEventListener('input', function () {
          self2.sync();
          if (!self2.el.blad.hidden) self2.pokazBlad();
        });
        this.el.recznyInput.addEventListener('invalid', function () { self2.pokazBlad(); });
      }
      this._sygnatury = {};

      this.addEventListener('change', this.naZmiane.bind(this));
      /* Horizon controleert form.checkValidity() bij de klik op „Toevoegen".
         Een onvolledige keuze maakt het merkveld ongeldig; dan start de
         animatie niet en tonen we welke velden ontbreken. */
      var self1 = this;
      this.el.marka.addEventListener('invalid', function () { self1.pokazBlad(); });
      this.sync();
    }

    naZmiane(e) {
      var t = e.target, pole;
      if (t.dataset.field) {
        pole = t.dataset.field;
        this.s[pole] = t.value;
      } else if (t.type === 'radio') {
        pole = t.closest('[data-group]').dataset.group;
        this.s[pole] = t.dataset.key || t.value;
      } else {
        return;
      }
      for (var i = POLA.indexOf(pole) + 1; i < POLA.length; i++) this.s[POLA[i]] = '';
      this.sync();
      if (!this.el.blad.hidden) this.pokazBlad(); // odśwież listę braków
    }

    /* Porządkuje stan od góry do dołu, auto-wybiera jedyne opcje, rysuje UI. */
    nazwaNadwozia(k) { return this.etykiety[k] || this.etykietyNl[k] || this.A.n[k] || k; }
    wartoscNadwozia(k) { return this.etykietyNl[k] || this.A.n[k] || k; }
    nazwaModelu(m) { return this.modele[m] || m; }
    nazwaDrzwi(d) {
      var i = this.drzwiOpcje.indexOf(d);
      return (i > -1 && this.drzwiEtykiety[i]) || d;
    }

    sync() {
      var A = this.A, s = this.s, self = this;

      var marka = znajdz(A.m, 'b', s.marka);
      if (!marka) s.marka = '';
      var modele = marka ? marka.m : [];
      if (modele.length === 1) s.model = modele[0].m;

      var model = znajdz(modele, 'm', s.model);
      if (!model) s.model = '';
      var generacje = model ? model.g : [];
      if (generacje.length === 1) s.generacja = generacje[0][0];

      var gen = null;
      for (var i = 0; i < generacje.length; i++) if (generacje[i][0] === s.generacja) gen = generacje[i];
      if (!gen) s.generacja = '';
      var nadwozia = gen ? gen[1] : [];
      if (nadwozia.length === 1) s.nadwozie = nadwozia[0];
      if (nadwozia.indexOf(s.nadwozie) === -1) s.nadwozie = '';

      var drzwiAktywne = !!s.nadwozie && A.czyDrzwi(s.nadwozie);
      if (!drzwiAktywne || this.drzwiOpcje.indexOf(s.drzwi) === -1) s.drzwi = '';

      this.wypelnij(this.el.marka, A.m.map(function (b) { return b.b; }), s.marka, false);
      this.wypelnij(this.el.model, modele.map(function (m) { return m.m; }), s.model, !marka,
        function (m) { return self.nazwaModelu(m); });
      this.wypelnij(this.el.generacja, generacje.map(function (g) { return g[0]; }), s.generacja, !model);

      this.radia(this.el.nadwozie,
        nadwozia.map(function (k) { return { klucz: k, etykieta: self.nazwaNadwozia(k), wartosc: self.wartoscNadwozia(k) }; }),
        s.nadwozie, gen ? '' : this.el.nadwozie.dataset.pending);

      var drzwiKomunikat = !s.nadwozie ? this.el.drzwi.dataset.pending
        : (!drzwiAktywne ? this.el.drzwi.dataset.locked : '');
      this.radia(this.el.drzwi,
        drzwiAktywne ? this.drzwiOpcje.map(function (d) { return { klucz: d, etykieta: self.nazwaDrzwi(d), wartosc: d }; }) : [],
        s.drzwi, drzwiKomunikat);

      // Reguły z bazy — tylko informacja, nic nie jest doliczane do ceny.
      var doplata = !!s.nadwozie && A.czyDoplata(s.nadwozie);
      var kontakt = !!s.nadwozie && A.czyKontakt(s.nadwozie);
      this.el.flagaDoplata.disabled = !doplata;
      this.el.flagaKontakt.disabled = !kontakt;
      this.el.notaDoplata.hidden = !doplata;
      this.el.notaKontakt.hidden = !kontakt;
      var kwota = A.reguly && A.reguly.doplataKwota;
      if (typeof kwota === 'number' && this.el.kwota) {
        this.el.kwota.textContent = ' ' + new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', {
          style: 'currency', currency: this.dataset.currency || 'EUR'
        }).format(kwota);
      }

      this.statusKrokow(drzwiAktywne);
      this.trybReczny();

      var kompletny = this.czyKompletny();
      this.el.podsumowanie.hidden = !kompletny;
      if (kompletny) {
        var czesci = [s.marka + ' ' + this.nazwaModelu(s.model), s.generacja, this.nazwaNadwozia(s.nadwozie)];
        if (s.drzwi) czesci.push((this.nazwaDrzwi(s.drzwi) + ' ' + (this.dataset.drzwiJednostka || '')).trim());
        this.el.podsumowanieTekst.textContent = this.handmatig && this.el.recznyInput
          ? this.el.recznyInput.value.trim() : czesci.join(', ');
        this.el.blad.hidden = true;
      }
      this.dataset.complete = kompletny ? 'true' : 'false';
      this.el.marka.setCustomValidity(kompletny ? '' :
        ((this.dataset.errorText || '') + ' ' + this.nazwyBrakow().join(', ')).trim());

      zapamietane[this.klucz] = Object.assign({ _handmatig: this.handmatig }, s);
    }

    /* Schakelt tussen de lijst en handmatige invoer. In handmatige modus worden
       de lijstvelden uitgeschakeld (en dus niet meegestuurd) en geldt de
       regel voor e-mailbevestiging, net als bij bus en pick-up. */
    trybReczny() {
      var r = this.handmatig && !!this.el.recznyInput;
      if (!this.el.reczny) return;
      this.el.reczny.hidden = !r;
      this.el.recznyInput.disabled = !r;
      this.el.recznyInput.required = r;
      if (this.el.kroki) this.el.kroki.hidden = r;
      var p = this.el.recznyPrzycisk;
      if (p) p.textContent = r ? (p.dataset.textOff || '') : (p.dataset.textOn || '');
      if (r) {
        this.querySelectorAll('[data-steps] select, [data-steps] input').forEach(function (el) { el.disabled = true; });
        this.el.flagaDoplata.disabled = true;
        this.el.notaDoplata.hidden = true;
        this.el.flagaKontakt.disabled = false;
        this.el.notaKontakt.hidden = false;
      } else {
        this.querySelectorAll('[data-steps] input').forEach(function (el) { el.disabled = false; });
      }
    }

    wypelnij(select, wartosci, wybrana, zablokowany, etykieta) {
      var syg = wartosci.join('\u0001');
      if (this._sygnatury[select.dataset.field] !== syg) {
        this._sygnatury[select.dataset.field] = syg;
        select.length = 1; // zostaje placeholder
        wartosci.forEach(function (w) { select.add(new Option(etykieta ? etykieta(w) : w, w)); });
      }
      select.value = wybrana;
      select.disabled = zablokowany;
    }

    radia(grupa, opcje, wybrany, komunikat) {
      var lista = grupa.querySelector('[data-options]');
      var info = grupa.querySelector('[data-info]');
      var syg = opcje.map(function (o) { return o.klucz; }).join('\u0001');
      var pole = grupa.dataset.group;
      if (this._sygnatury[pole] !== syg) {
        this._sygnatury[pole] = syg;
        lista.textContent = '';
        var self = this;
        opcje.forEach(function (o) {
          var id = 'ak-' + self.klucz + '-' + pole + '-' + o.klucz;
          var input = document.createElement('input');
          input.type = 'radio';
          input.className = 'ak__radio';
          input.id = id;
          input.name = grupa.dataset.name;
          input.value = o.wartosc != null ? o.wartosc : o.etykieta; // altijd Nederlands in de bestelling
          input.dataset.key = o.klucz;       // klucz z bazy
          if (self.formId) input.setAttribute('form', self.formId);
          var label = document.createElement('label');
          label.className = 'ak__pill';
          label.htmlFor = id;
          label.textContent = o.etykieta;
          lista.appendChild(input);
          lista.appendChild(label);
        });
      }
      Array.prototype.forEach.call(lista.querySelectorAll('input'), function (inp) {
        inp.checked = inp.dataset.key === wybrany;
      });
      lista.hidden = opcje.length === 0;
      info.hidden = !komunikat;
      info.textContent = komunikat || '';
    }

    statusKrokow(drzwiAktywne) {
      var s = this.s, poprzedniGotowy = true, self = this;
      POLA.forEach(function (pole) {
        var krok = self.querySelector('[data-step="' + pole + '"]');
        var nieDotyczy = pole === 'drzwi' && !!s.nadwozie && !drzwiAktywne;
        var status;
        if (nieDotyczy) status = 'skipped';
        else if (s[pole]) status = 'done';
        else status = poprzedniGotowy ? 'active' : 'locked';
        krok.dataset.status = status;
        poprzedniGotowy = status === 'done' || status === 'skipped';
      });
    }

    braki() {
      var s = this.s, wynik = [];
      if (this.handmatig && this.el.recznyInput) {
        return this.el.recznyInput.value.trim() ? [] : ['handmatig'];
      }
      ['marka', 'model', 'generacja', 'nadwozie'].forEach(function (pole) { if (!s[pole]) wynik.push(pole); });
      // Drzwi są wymagane tylko, gdy reguła z bazy mówi, że mają sens dla tego nadwozia.
      if (s.nadwozie && this.A.czyDrzwi(s.nadwozie) && !s.drzwi) wynik.push('drzwi');
      return wynik;
    }

    czyKompletny() { return this.braki().length === 0; }

    nazwyBrakow() {
      var self = this;
      return this.braki().map(function (pole) {
        var l = pole === 'handmatig' ? self.querySelector('[data-manual] .ak__label')
          : self.querySelector('[data-step="' + pole + '"] .ak__label');
        return l ? l.textContent.trim() : pole;
      });
    }

    pokazBlad() {
      var nazwy = this.nazwyBrakow();
      this.el.bladLista.textContent = nazwy.join(', ');
      this.el.blad.hidden = nazwy.length === 0;
      return nazwy.length;
    }

    zablokujJesliNiekompletny(e) {
      if (this.czyKompletny()) return false;
      e.preventDefault();
      e.stopImmediatePropagation();
      this.pokazBlad();
      var pierwszy = this.braki()[0];
      var cel = pierwszy === 'handmatig' ? this.el.recznyInput : this.querySelector('[data-step="' + pierwszy + '"] select:not([disabled]), [data-step="' + pierwszy + '"] input');
      if (cel) cel.focus();
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
  }

  window.customElements.define('auto-configurator', AutoKonfigurator);

  /* Blokada „Dodaj do koszyka" — faza capture, więc działa PRZED
     obsługą AJAX motywu (Dawn i pochodne mają novalidate na formularzu). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var konfiguratory = document.querySelectorAll('auto-configurator');
    for (var i = 0; i < konfiguratory.length; i++) {
      var k = konfiguratory[i];
      if (k._gotowy && k.formId && form.id === k.formId && k.zablokujJesliNiekompletny(e)) return;
    }
  }, true);
})();
